import React, { useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { useState } from "react";

// css
import styles from "../../../layout/Auth/Auth.module.scss";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import activateAccountSchema from "./ActivateAccount.schema";
import LoadingButton from "components/shared/LoadingButton";
import { LOGIN } from "config/paths";
import { EyeCloseIcon, EyeOpenIcon, PadLockIcon } from "Assets/icons";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import { useActivateAccountMutation, useVerifyActivationTokenQuery } from "store/services/users/account";

const ActivateAccount = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  const [showPassword, setShowPassword] = useState(false);

  const { data: verificationResult, isLoading, isError } = useVerifyActivationTokenQuery(token, { skip: !token });
  const [activateAccountSubmit, { isLoading: activateAccountLoading }] = useActivateAccountMutation();

  if (isError === true) {
    navigate(LOGIN)
  }

  const initialValues = useMemo(() => {
    if (!verificationResult) {
      return {};
    }

    return ({
      email: verificationResult?.email,
      username: verificationResult?.username,
    })
  }, [verificationResult])

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (values) => {
    try {
      await activateAccountSubmit({
        payload: {
          username: values.username,
          password: values.password,
        },
        token
      }).unwrap();

      navigate(LOGIN);
    } catch (err) {
      console.error("Error in ActivateAccount:", err);
    }
  }

  return (
    <>
      <div className="formInner position-relative px-lg-3">
        <div className="w-100 inner">
          <div className="top py-2 text-center">
            <h4 className="m-0 fw-bold py-1">Set Your Password</h4>
          </div>
          {isLoading ? (
            <LoadingIndicator />
          ) : isError ? (
            <ErrorComponent />
          ) : (
            <Formik
              initialValues={initialValues}
              validationSchema={activateAccountSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({
                handleSubmit,
                errors,
                isSubmitting,
              }) => (
                <Form className={`${styles.form} pt-2`} onSubmit={handleSubmit}>
                  <Row className="justify-content-center">
                    {/* <Col lg="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 pb-1 text-muted fw-sbold"
                      >
                        Username:
                      </label>
                      <AppInputField
                        name="username"
                        placeholder="john"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col> */}
                    {console.log('errors of formik', errors)}
                    <Col lg="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 pb-1 text-muted fw-sbold"
                      >
                        Email address:
                      </label>
                      <AppInputField
                        name="email"
                        placeholder="john******@gmail.com"
                        className={`${styles.formControl} form-control`}
                        disabled
                      />
                    </Col>
                    <Col lg="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 pb-1 text-muted fw-sbold"
                      >
                        Password
                      </label>
                      <div className="position-relative iconWithText">
                        <AppInputField
                          type={showPassword ? "text" : "password"}
                          className={`${styles.formControl} form-control`}
                          placeholder="*************"
                          name="password"
                        />
                        <Button
                          onClick={toggleShowPassword}
                          className="border-0 p-0 position-absolute icn"
                          variant="transparent"
                          style={{ right: 10 }}
                        >
                          {showPassword ? <EyeOpenIcon /> : <EyeCloseIcon />}
                        </Button>
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 pb-1 text-muted fw-sbold"
                      >
                        Confirm Password
                      </label>
                      <div className="position-relative iconWithText">
                        <AppInputField
                          type={showPassword ? "text" : "password"}
                          className={`${styles.formControl} form-control`}
                          placeholder="*************"
                          name="confirm_password"
                        />
                        <Button
                          onClick={toggleShowPassword}
                          className="border-0 p-0 position-absolute icn"
                          variant="transparent"
                          style={{ right: 10 }}
                        >
                          {showPassword ? <EyeOpenIcon /> : <EyeCloseIcon />}
                        </Button>
                      </div>
                    </Col>
                    {/* <Col lg="12" className="my-2">
                    <label
                      htmlFor=""
                      className="form-label m-0 pb-1 text-muted fw-sbold"
                    >
                      Confirm Password
                    </label>
                    <div className="position-relative iconWithText">
                      <AppInputField
                        type={showPassword ? "text" : "password"}
                        className={`${styles.formControl} form-control`}
                        placeholder="*************"
                        name="confirm_password"
                      />
                      <Button
                        onClick={toggleShowPassword}
                        className="border-0 p-0 position-absolute icn"
                        variant="transparent"
                        style={{ right: 10 }}
                      >
                        <PadLockIcon />
                      </Button>
                    </div>
                  </Col> */}
                    <Col lg="8" className="my-2">
                      <div className={`${styles.btnWrpper} pt-4 btnWrpper text-center`}>
                        <LoadingButton
                          type="submit"
                          className="d-flex align-items-center justify-content-center w-100 commonBtn"
                          isLoading={isLoading || activateAccountLoading}
                        >
                          Submit
                        </LoadingButton>
                        <Link to={LOGIN} className="mt-2 d-block themeClr">Return to Login</Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          )}
        </div>
      </div>
    </>
  );
};
export default ActivateAccount;
